import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const ProfitIcon = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 16}
        height={size ?? 17}
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <path d="M0 16.12H16V0.12H0V16.12Z" fill="url(#pattern0)" />
        <defs>
          <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlinkHref="#image0_39_102" transform="scale(0.00625)" />
          </pattern>
          <image id="image0_39_102" width="160" height="160" />
        </defs>
      </svg>
    );
  },
);
export default ProfitIcon;
